/*=========================================================================================
  File Name: module-usertax.js
  Description: UserTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-statebudget-state';
import mutations from './module-statebudget-mutations';
import actions from './module-statebudget-actions';
import getters from './module-statebudget-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
